import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { successNotification, errorNotification, warningNotification } from '../../notification';
import { FormFieldDrop, FormFieldGeneric } from '../../formField';
import FormRow from '../../formRow';
import Popup from '../layout';
import * as attendanceService from '../../../services/attendance';
import { useForms } from '../../../hooks';

const initialForm = {
  Nome: ''
};

const PopUpAttendanceType = ({ visible, setVisible, reloadAttendanceTypes, isEdit, entity }) => {
  const [form, updateForm, setForm] = useForms(initialForm);

  const createAttendanceType = async (body) => {
    const response = await attendanceService.createAttendanceType(body);
    const { data } = response;
    if (response.status === 200) {
      body = {
        ...body,
        Id: data,
        Editavel: true
      };
      successNotification('Tipo de proposta criado com sucesso!');
      await reloadAttendanceTypes(body);
    } else if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
    else errorNotification('Houve um erro ao tentar atualizar um tipo de proposta.');
  };

  const editAttendanceType = async (body) => {
    const response = await attendanceService.updateAttendanceType(body, body.Id);
    if (response.status === 200) {
      body = {
        Id: body.Id,
        Editavel: true,
        ...body
      };
      successNotification('Tipo de proposta atualizado com sucesso!');
      await reloadAttendanceTypes(body);
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar atualizar um tipo de proposta.');
    }
  };

  const excludeAttendanceType = async () => {
    const response = await attendanceService.excludeAttendanceType(entity.Id);
    if (response.status === 200) {
      successNotification('Tipo de proposta excluído com sucesso!');
      await reloadAttendanceTypes(null);
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar excluir um tipo de proposta.');
    }
  };

  const submitHandle = () => {
    const body = {
      Id: entity?.Id,
      ...form
    };

    return isEdit ? editAttendanceType(body) : createAttendanceType(body);
  };

  useEffect(() => {
    setForm(entity || initialForm);
  }, [entity, visible]);

  return (
    <Popup
      visible={visible}
      setVisible={setVisible}
      title="Tipo de Proposta"
      confirmText="Salvar"
      cancelText="Cancelar"
      haveExclude={isEdit}
      onConfirm={submitHandle}
      onDelete={excludeAttendanceType}
    >
      <FormRow>
        <FormFieldGeneric
          titleLabel="Nome"
          classNameWrapper="fill-100-field-tooltip"
          name="Nome"
          onChangeValue={updateForm}
          valueInput={form.Nome}
          required
        />
      </FormRow>
    </Popup>
  );
};

PopUpAttendanceType.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reloadAttendanceTypes: PropTypes.func.isRequired
};

export default PopUpAttendanceType;
